import AIOApis from "./../../components/aio/aio-apis";
import UploadFileIcon from "assets/icons/UploadFileIcon";
import useExcel from "components/boxit-excel";
import OrderDataTopNav from "pages/OrderManagement/views/Order/OrderDataTopNav";
import { ChangeEvent, FC, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const OrderExcel: FC = () => {
    const navigate = useNavigate();
    let base_url = process.env.REACT_APP_BASE_URL;
    if (base_url[base_url.length - 1] !== '/') {
        base_url += '/';
    }
    const token = localStorage.getItem('token')
    const [apis] = useState<Apis>(new Apis({ token, base_url }))
    const orderData = useSelector(state => (state as any).Order)
    const { filter: { selectHub } } = useSelector(state => (state as any).OrderManagement)
    const customerId = orderData.orderData.senderCustomerId
    const customerIdRef = useRef<any>(customerId)
    customerIdRef.current = customerId
   
    const { returnAddressId, fromCountryDevisionId } = orderData
    const excel = useExcel({
        validateUrl: `${base_url}consignment-api/excel-api/hub/validationExcel`,
        keys: [
            { defaultValue: '2000000', en: 'value', fa: 'ارزش(ریال)' },
            { defaultValue: 'تهران', en: 'province', fa: 'استان' },
            { defaultValue: '1000010000000', en: 'cprNumber', fa: 'شماره بارکد باکسیت' },
            { defaultValue: 'تهران', en: 'receiverCity', fa: 'شهر مقصد' },
            { defaultValue: '20', en: 'length', fa: 'طول (سانتی متر)' },
            { defaultValue: '15', en: 'height', fa: 'ارتفاع (سانتی متر)' },
            { defaultValue: '2', en: 'width', fa: 'عرض (سانتی متر)' },
            { defaultValue: '09120000000', en: 'receiverMobile', fa: 'موبایل گیرنده' },
            { defaultValue: 'تست گیرنده', en: 'receiver', fa: 'نام و نام خانوادگی گیرنده' },
            { defaultValue: 'تهران، بلوار انقلاب،....', en: 'address', fa: 'نشانی مقصد' },
            { defaultValue: '', en: 'costOfGoods', fa: 'هزینه کالا در مقصد(ریال)' },
            { defaultValue: '2', en: 'weight', fa: 'وزن(کیلوگرم)' },
            { defaultValue: 'بسته', en: 'consignmentType', fa: 'نوع مرسوله' },
            { defaultValue: '', en: 'customerCprNumber' },
            { defaultValue: 'غیر اسناد و مدارک', en: 'contentType', fa: 'نوع محتوا' },
            { defaultValue: '', en: 'contentCode' },
            { defaultValue: 'سایز2', en: 'packageId', fa: 'سایز' },
            { defaultValue: '', en: 'postPay', fa: 'کرایه در مقصد' },
            { defaultValue: '', en: 'customerCprNumber', fa: 'شماره مرسوله مشتری' },
            { defaultValue: '', en: 'description', fa: 'توضیحات' },
            { defaultValue: 'خیر', en: 'thirdPartyDelivery', fa: 'توزیع غیر باکسیت', nullValue: (index: number) => 'خیر' }
        ],
        onClose: () => setTheFile(undefined),
        onSuccess: (json: any) => { handleSubmit(json) },
        extendRowToServer: (row, index) => {
            const customerId = customerIdRef.current
            const thirdPartyDelivery = row.thirdPartyDelivery === 'بله' ? true : false
            const res = { ...row, index: index + 1, customerId, thirdPartyDelivery }
            return res
        }
    })

    const inputRef = useRef<HTMLInputElement>(null);
    const [theFile, setTheFile] = useState<any>();
    const excelInfo = {
        url: "consignment-api/consignment/importConsignmentExcelFile",
        fileName: "order.xlsx",
        Entity: "a",
        hasExtra: true
    }
    const handleOpenUpload = () => inputRef?.current?.click();

    const [dragActive, setDragActive] = useState<boolean>(false);

    const handleDrag = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };
    const handleDrop = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            if (
                e.dataTransfer.files[0].type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
                setTheFile(e.dataTransfer.files[0]);
            } else {
                toast.error("فرمت فایل صحیح نیست");
            }
        }
    };
    const handleSubmit = async (json: any) => {
        debugger
        let bodyFormData = new FormData();
        bodyFormData.append("file", theFile);
        // excelInfo.Entity && bodyFormData.append("Entity", excelInfo.Entity);
        const res = await apis.sendExcel({
            returnHubId: selectHub.id,
            pickupHubId: selectHub.id,
            originHubId: selectHub.id,
            sender: { id: customerIdRef.current },
            excel: json
        })
        if (res) {
            navigate('/order-management')
        }
    };
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            setTheFile(e.target.files[0]);
        } else {
            toast.error("فرمت فایل صحیح نیست");
        }
    };
    return (
        <div className="flex flex-col items-center gap-[24px] h-full w-full">
            <div className="w-full bg-white flex-row justify-center">
                <OrderDataTopNav returnAddress={true}/>
            </div>
            <div className="flex-row flex items-center justify-center flex-1 w-full" style={{ background: '#f7f7f7' }}>
                {
                    !theFile && !!customerIdRef.current && 
                    <form onSubmit={handleSubmit} className="centering flex-col w-[30rem]">
                        <div className="text-center mb-5 w-full" onDragEnter={(e: any) => handleDrag(e)}>
                            <input
                                accept=".xlsx"
                                type="file"
                                id="input-file-upload"
                                ref={inputRef}
                                multiple={true}
                                onChange={handleChange}
                                className="hidden"
                            />
                            <label
                                id="label-file-upload"
                                htmlFor="input-file-upload"
                                className={`centering border-2 border-dashed border-tomato  py-3 ${dragActive ? "bg-lightTomato" : "bg-light"
                                    } `}
                            >
                                <div className="my-4 centering flex-col gap-3  ">
                                    <UploadFileIcon />
                                    <p className="text-base text-darkGray leading-7 text-center">
                                        فایل را در این قسمت بکشید و رها کنید <br />
                                        یا یک
                                        <button
                                            type="button"
                                            className="px-1 text-tomato underline cursor-pointer"
                                            onClick={handleOpenUpload}
                                        >
                                            فایل آپلود
                                        </button>
                                        کنید
                                    </p>
                                    <span className={`my-2 ${theFile ? "text-green" : "text-red"}`}>
                                        {theFile ? theFile?.name : "فایلی وجود ندارد"}
                                    </span>
                                </div>
                            </label>
                            {dragActive && (
                                <div
                                    className="absolute w-full h-full rounded-[1px] top-0	right-0 bottom-0 left-0	"
                                    id="drag-file-element"
                                    onDragEnter={(e: any) => handleDrag(e)}
                                    onDragLeave={(e: any) => handleDrag(e)}
                                    onDragOver={(e: any) => handleDrag(e)}
                                    onDrop={(e: any) => handleDrop(e)}
                                ></div>
                            )}
                        </div>
                        <div className="flex-between-start w-full">
                            <a
                                href={require(`../../assets/sample/${excelInfo.fileName}`)}
                                download={excelInfo.fileName}
                                className="btn px-0 w-fit "
                                target={"_blank"}
                                rel="noreferrer"
                            >
                                دانلود قالب فایل
                            </a>
                            <button
                                onClick={()=>navigate(-1)} 
                                type='button'
                                style={{
                                    border: '2px solid #333',
                                    borderRadius: 24,
                                    padding: '8px 32px',
                                    background: '#fff'
                                }}
                            >خروج</button>
                        </div>
                    </form>
                }
                {!!theFile && excel(theFile)}
            </div>
        </div>
    )
}
export default OrderExcel



class Apis extends AIOApis {
    constructor(p: { token: string, base_url: string }) {
        super({
            id: 'adminexcel',
            handleErrorMessage: (err) => {
                return err.response.data.messages[0].message
            },
            lang: 'fa',
            token: p.token ,
            base_url:p.base_url
        })
    }
    sendExcel = async (body) => {
        const { success } = await this.request({
            name: 'sendExcel',
            description: 'ارسال دیتای اکسل',
            url: `consignment-api/excel-api/hub/importExcelOrder`,
            method: 'post',
            body,
        })
        return !!success
    }
}